import React, { useEffect } from "react";
import { Route, Switch, useHistory } from "react-router-dom";
import Home from "./pages/Home";
import PlaceBet from "./pages/PlaceBet";
import PersonalDetails from "./pages/PersonalDetails";
import LotteryBetSlip from "./pages/LotteryBetSlip";
import BookingCheck from "./pages/BookingCheck";
import Final from "./pages/Final";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	InputLabel,
	List,
	ListItem,
	ListItemText,
	TextField,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "./redux/items/Language";
import LanguageIcon from "@material-ui/icons/Language";
import HomeIcon from "@material-ui/icons/Home";
import ChooseBetCheck from "./pages/ChooseBetCheck";
import NotFound from "./pages/NotFound";
import Toto from "./pages/TotoPlaceBet";
import TotoCheckout from "./pages/TotoCheckout";
import TotoPersonalDetails from "./pages/TotoPersonalDetails";
import Refer from "./pages/Refer";

import GroupAddIcon from "@material-ui/icons/GroupAdd";
import ReactCountryFlag from "react-country-flag";
import PhoneInput from "react-phone-number-input";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import Booking from "./pages/Booking";
import PaymentHistory from "./pages/PaymentHistory";
import RetailerAccount from "./pages/RetailerAccount";
import { If, Then } from "react-if";
import Deposit from "./pages/Deposit";
import Withdrawals from "./pages/Withdrawal";

import style from "./assets/css/style";
import FetchNoLogin from "./components/Fetch/FetchNoLogin";
import Debug from "./Debug";
import FetchLogin from "./components/Fetch/FetchLogin";
import { useState } from "react";
import { setPersonalDetails } from "./redux/items/PersonalDetails";
import Set from "./pages/Set";
import Agent from "./pages/Agent";
import AgentHistory from "./pages/AgentHistory";
import { Fetch2 } from "./utils/functions";
import fatcat from "./assets/image/fatcat.png";
import { setLogin } from "./redux/items/LoginReducer";

let pusherInstance;

const App = observer(() => {
	const language = useSelector((state) => state.Language);
	const pageLoading = useSelector((state) => state.pageLoading);
	const token = useSelector((state) => state.login.token);
	const credits = useSelector((state) => state.login.user?.credits);
	const Maintenance = useSelector((state) => state?.Maintenance);
	const router = useSelector((state) => state.router.location.pathname);
	const TotoSet = useSelector((state) => state.drawSet?.TotoSet);
	const loginUser = useSelector((state) => state.login?.user);
	const login = useSelector((state) => state.login);

	const enable_book_toto = useSelector(
		(state) => state.drawSet.set?.enable_book_toto
	);
	const dispatch = useDispatch();
	const hist = useHistory();
	const DialogLogin = useSelector((state) => state.DialogLogin);
	// const PopUpMessage = useSelector((state) => state.PopUp.message);
	// const PopUpRead = useSelector((state) => state.PopUp.read);

	const app_pop_up = useSelector((state) => state.drawSet.set?.app_pop_up);
	const app_pop_up_link = useSelector(
		(state) => state.drawSet.set?.app_pop_up_link
	);

	// const inputRef = useRef();

	const [v, setV] = useState({
		form: 1,
		mobileNumber: "",
		otp: "",
		error: "",
		errorOtp: "",
		pin: "",
		errorPin: "",

		pinMode: 0,

		modalCredit: false,

		disableSubmitBtn: true,
		currentTime: new Date().valueOf(),

		popup: true,
	});

	const setV2 = (v2) => {
		setV((prev) => ({ ...prev, ...v2 }));
	};

	const reqInfo = FetchLogin("info", {
		data: {
			token: token,
		},
	});

	const reqLogin = FetchNoLogin("login-otp", {
		data: {
			contactNo: v.mobileNumber,
		},
		callbackInit: () => {
			setV2({ error: "", disableSubmitBtn: true });

			let d = new Date();
			d.setMinutes(d.getMinutes() + 5);
			localStorage.setItem("time_login_ls", d.valueOf());
		},
		callback: (cb) => {
			if (!cb.response.success) {
				setV2({ error: cb.response.message });
			} else {
				setV2({ form: 2 });
			}
		},
	});

	const reqOtp = FetchLogin("login-otp-check", {
		data: {
			contactNo: v.mobileNumber,
			otp: v.otp,
		},
		callbackInit: () => {
			setV2({ errorOtp: "" });
		},
		callback: (cb) => {
			if (!cb.response.success) {
				setV2({ errorOtp: cb.response.message });
			} else {
				let user = cb.response.data.user.user;
				dispatch(
					setPersonalDetails({
						name: user.name,
						email: user.email,
					})
				);
				// setTimeout(() => {
				//   window.location.reload();
				// }, 100);
			}
		},
	});

	const reqPin = FetchLogin("login-pin", {
		data: {
			contactNo: v.mobileNumber,
			pin: v.pin,
		},
		callbackInit: () => {
			setV2({ errorPin: "" });
		},
		callback: (cb) => {
			if (!cb.response.success) {
				setV2({ errorPin: cb.response.message });
			} else {
				let user = cb.response.data.user.user;
				dispatch(
					setPersonalDetails({
						name: user.name,
						email: user.email,
					})
				);
				// setTimeout(() => {
				// 	window.location.reload();
				// }, 100);
			}
		},
	});

	const reqVersion = Fetch2("version", {
		data: {
			version: 12,
			origin: window.origin,
		},
		callback: (cb) => {
			if (cb.response?.redirect) {
				if (cb.response.redirect === "reload") {
					// window.location.reload();
				} else if (cb.response.redirect.trim() !== "") {
					window.location.href = cb.response.redirect.trim();
				}
			}
		},
	});

	const reqLogout = FetchLogin("logout", {
		data: {
			token: token,
		},
	});

	// const otpEnter = (e) => {
	//   if (e.key === "Enter") {
	//     reqLogin.handleTrigger({ contactNumber: v.mobileNumber });
	//   }
	// };

	// useEffect(() => {
	//   if (prevDrawSet !== undefined) {
	//     console.log(drawSet);
	//     // window.location.reload();
	//   }
	// }, [drawSet]);
	useEffect(() => {
		if (token) {
			reqInfo.handleTrigger();
		}
		reqVersion.handleTrigger();

		// setTimeout(() => {
		//   inputRef.current.addEventListener("keydown", otpEnter);
		// }, 0);

		return () => {
			// eslint-disable-next-line
			// inputRef.current.removeEventListener("keydown", otpEnter);
		};

		// eslint-disable-next-line
	}, []);

	useEffect(() => {
		if (token) {
			pusherInstance = new window.Pusher("fd72fcb329c65bcfdbce", {
				cluster: "ap1",
				authEndpoint: process.env.REACT_APP_BASE_URL_API + "/auth",
			});

			pusherInstance.connection.bind("connected", function () {
				let channel = pusherInstance.subscribe("private-my-channel");
				channel.bind("credit." + loginUser.contact_no, function (data) {
					dispatch(
						setLogin({
							...login,
							user: {
								...loginUser,
								credits: data.credits,
							},
						})
					);
				});
			});
		}
		return () => {
			if (pusherInstance) {
				pusherInstance.disconnect();
			}
		};
		// eslint-disable-next-line
	}, [token]);

	useEffect(() => {
		//
		let timer;
		if (localStorage.getItem("paynow_timer")) {
			let countdown = localStorage.getItem("paynow_timer");
			if (countdown > 0) {
				timer = setInterval(() => {
					countdown--;
					localStorage.setItem("paynow_timer", countdown);
					if (countdown < 1) {
						clearInterval(timer);
					}
				}, 1e3);
			}
		}

		let time_login;
		if (localStorage.getItem("time_login_ls")) {
			let time_login_countdown = localStorage.getItem("time_login_ls");
			time_login = setInterval(() => {
				// setV2({ currentTime: new Date().valueOf() });

				// console.log(time_login_countdown - new Date().valueOf());

				if (time_login_countdown < new Date().valueOf()) {
					setV2({ disableSubmitBtn: false });
					clearInterval(time_login);
				}
			}, 1e3);
		} else {
			setV2({ disableSubmitBtn: false });
		}
	}, [
		// eslint-disable-next-line
		null,
		// eslint-disable-next-line
		localStorage.getItem("paynow_timer"),
		// eslint-disable-next-line
		localStorage.getItem("time_login_ls"),
	]);

	useEffect(() => {
		if (token === undefined) {
			setV2({
				form: 1,
				mobileNumber: "",
				otp: "",
				pin: "",
			});
		}
	}, [token]);

	useEffect(() => {
		if (enable_book_toto) {
			if (TotoSet === undefined) window.location.reload();
		}
		// eslint-disable-next-line
	}, []);

	// useEffect(() => {
	// 	if (
	// 		app_pop_up !== "" &&
	// 		app_pop_up !== PopUpMessage &&
	// 		app_pop_up !== "empty"
	// 	) {
	// 		dispatch(
	// 			setPopUp({ message: app_pop_up, link: app_pop_up_link, read: false })
	// 		);
	// 	}
	// }, [null, app_pop_up, app_pop_up_link]);

	const creditBalance = (routerF) => {
		let router_list = ["/retailer-account", "/deposit", "/withdrawals"];
		return router_list.indexOf(routerF) <= -1;
	};

	const dialog_show = () => {
		if (process.env.REACT_APP_NAME !== "SGPools") {
			return !(["/", "/debug"].indexOf(router) > -1);
		}
		return true;
	};

	return (
		<Container
			maxWidth="sm"
			style={
				{
					// paddingTop: process.env.REACT_APP_YES_APP === undefined ? 0 : 10,
				}
			}
		>
			{pageLoading && (
				<div
					style={{
						backgroundColor: "rgba(0,0,0,.2)",
						width: "100%",
						height: "100%",
						position: "fixed",
						top: 0,
						left: 0,
						zIndex: 1400,
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress />
				</div>
			)}
			<If condition={token || process.env.REACT_APP_NAME !== "SGPools"}>
				<Then>
					<Container
						maxWidth="sm"
						style={{
							position: "relative",
						}}
					>
						<div
							style={{
								textAlign: "right",
								position: "absolute",
								width: 50,
								maxWidth: 50,
								right: 70,
								zIndex: 1,
								padding: "4px 8px",
								margin: 0,
							}}
						>
							<HomeIcon
								style={{
									top: 5,
									left: 0,
									position: "absolute",
									backgroundColor: "#fff",
									borderRadius: "50%",
									padding: 4,
									cursor: "pointer",
									marginRight: 100,
								}}
								onClick={() => {
									hist.push("/");
								}}
							/>
						</div>
						<div
							style={{
								textAlign: "right",
								position: "absolute",
								width: 50,
								maxWidth: 50,
								right: 20,
								zIndex: 1,
								padding: "4px 8px",
								margin: 0,
							}}
						>
							<GroupAddIcon
								style={{
									top: 5,
									left: 0,
									position: "absolute",
									backgroundColor: "#fff",
									borderRadius: "50%",
									padding: 4,
									cursor: "pointer",
									marginRight: 100,
								}}
								onClick={() => {
									hist.push("/refer");
								}}
							/>
						</div>
						<Container
							maxWidth="sm"
							style={{
								textAlign: "right",
								position: "absolute",
								width: 50,
								maxWidth: 50,
								right: 0,
								zIndex: 1,
								padding: "4px 8px",
							}}
						>
							<LanguageIcon
								style={{
									backgroundColor: "#fff",
									borderRadius: "50%",
									padding: 4,
									cursor: "pointer",
								}}
								onClick={() => {
									dispatch(setLanguage(false));
								}}
							/>
						</Container>
					</Container>
				</Then>
			</If>
			<Dialog maxWidth="xs" open={!language}>
				<DialogTitle>Choose your Language</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<List>
							<ListItem
								button
								component="a"
								onClick={() => {
									dispatch(setLanguage("en"));
								}}
							>
								<ListItemText>
									<ReactCountryFlag
										svg
										countryCode="US"
										style={{
											fontSize: "2em",
										}}
									/>{" "}
									English
								</ListItemText>
							</ListItem>

							<ListItem
								button
								component="a"
								onClick={() => {
									dispatch(setLanguage("cn"));
								}}
							>
								<ListItemText>
									{" "}
									<ReactCountryFlag
										svg
										countryCode="cn"
										style={{
											fontSize: "2em",
										}}
									/>{" "}
									Chinese
								</ListItemText>
							</ListItem>

							<ListItem
								button
								component="a"
								onClick={() => {
									dispatch(setLanguage("th"));
								}}
							>
								<ListItemText>
									<ReactCountryFlag
										svg
										countryCode="Th"
										style={{
											fontSize: "2em",
										}}
									/>{" "}
									Thai
								</ListItemText>
							</ListItem>

							<ListItem
								button
								component="a"
								onClick={() => {
									dispatch(setLanguage("id"));
								}}
							>
								<ListItemText>
									<ReactCountryFlag
										svg
										countryCode="id"
										style={{
											fontSize: "2em",
										}}
									/>{" "}
									Bahasa Indonesia
								</ListItemText>
							</ListItem>

							<ListItem
								button
								component="a"
								onClick={() => {
									dispatch(setLanguage("ph"));
								}}
							>
								<ListItemText>
									<ReactCountryFlag
										svg
										countryCode="ph"
										style={{
											fontSize: "2em",
										}}
									/>{" "}
									Tagalog
								</ListItemText>
							</ListItem>
							<ListItem
								button
								component="a"
								onClick={() => {
									dispatch(setLanguage("vn"));
								}}
							>
								<ListItemText>
									<ReactCountryFlag
										svg
										countryCode="vn"
										style={{
											fontSize: "2em",
										}}
									/>{" "}
									Vietnam
								</ListItemText>
							</ListItem>
						</List>
					</DialogContentText>
				</DialogContent>
			</Dialog>
			<Dialog
				maxWidth="sm"
				open={(() => {
					if (process.env.REACT_APP_YES_APP === undefined) {
						return !token && dialog_show() && !(router.indexOf("/check") > -1);
					} else {
						return DialogLogin;
					}
				})()}
			>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<div>
						{/* <IconButton
							style={{
								position: "absolute",
								right: 8,
								top: 8,
							}}
							onClick={() => {
								if (process.env.REACT_APP_YES_APP !== undefined) {
									dispatch(setDialogLogin(false));
								}
							}}
						>
							<Close />
						</IconButton> */}
						<div style={{ padding: "0 10px" }}>
							<h2>Login</h2>
						</div>
						{v.form === 1 && (
							<>
								{process.env.REACT_APP_NAME !== "SGPools" ? (
									<div style={{ padding: 10, marginTop: -20 }}>
										<Link to="/">Back to Home</Link>
									</div>
								) : null}
								<div style={{ padding: "0 10px" }}>
									<InputLabel>Mobile Number</InputLabel>
									<PhoneInput
										defaultCountry="SG"
										placeholder="98765432"
										onChange={(e) => {
											setV2({ mobileNumber: e });
										}}
										value={v.mobileNumber}
										style={{ marginTop: 10, marginBottom: 10 }}
										// ref={inputRef}
									/>

									<If condition={v.pinMode === 1}>
										<Then>
											<div>
												<InputLabel>Pin</InputLabel>
												<TextField
													type="number"
													value={v.pin}
													onChange={(e) => setV2({ pin: e.target.value })}
													variant="outlined"
													fullWidth={true}
												/>
											</div>
										</Then>
									</If>
									<p
										dangerouslySetInnerHTML={{
											__html: v.error,
										}}
										style={{ color: "red" }}
									/>
									<p
										dangerouslySetInnerHTML={{
											__html: v.errorPin,
										}}
										style={{ color: "red" }}
									/>
								</div>
								<DialogActions>
									<>
										<If condition={v.pinMode === 1}>
											<Then>
												<Button
													color="default"
													type="button"
													onClick={() => {
														setV2({ pinMode: 0 });
													}}
												>
													Back
												</Button>{" "}
												<Button
													type="button"
													onClick={() => {
														reqPin.handleTrigger();
													}}
												>
													Submit
												</Button>
											</Then>
										</If>
										<If condition={v.pinMode === 0}>
											<Then>
												<Button
													color="default"
													type="button"
													onClick={() => {
														setV2({ pinMode: 1 });
													}}
												>
													Login with Pin
												</Button>{" "}
												<Button
													type="button"
													onClick={() => {
														reqLogin.handleTrigger();
													}}
													// disabled={v.disableSubmitBtn}
												>
													Login with OTP
													{/* {sec(v.currentTime)} */}
												</Button>
											</Then>
										</If>
									</>
								</DialogActions>
							</>
						)}
						{v.form === 2 && (
							<>
								<div style={{ padding: 10, paddingTop: 0 }}>
									Mobile Number: <b>{v.mobileNumber}</b>
									<div style={{ paddingTop: 10 }}>
										<InputLabel>OTP</InputLabel>
										<TextField
											value={v.otp}
											onChange={(e) => setV2({ otp: e.target.value })}
											variant="outlined"
											fullWidth={true}
										/>
										<p>
											OTP Not received?{" "}
											<a
												href="https://sgpoolsretailer.com/support"
												target="_blank"
												rel="noreferrer"
											>
												Contact us
											</a>
										</p>
										<p
											dangerouslySetInnerHTML={{
												__html: v.errorOtp,
											}}
											style={{ color: "red" }}
										/>
									</div>
								</div>
								<DialogActions>
									<>
										<Button
											type="button"
											onClick={() => {
												setV2({ form: 1 });
											}}
											// disabled={v.disableSubmitBtn}
										>
											Back
											{/* {sec(v.currentTime)} */}
										</Button>
										<Button
											type="button"
											onClick={() => {
												reqOtp.handleTrigger();
											}}
										>
											Submit
										</Button>
									</>
								</DialogActions>
							</>
						)}
					</div>
					{process.env.REACT_APP_NAME !== "SGPools" ? null : (
						<div
							style={{
								width: "100px",
							}}
						>
							<img
								src={fatcat}
								alt="fatcat"
								style={{
									width: "100%",
									height: "100%",
									// borderRadius: "50%",
								}}
							/>
						</div>
					)}
				</div>
			</Dialog>
			<Dialog
				open={v.modalCredit}
				maxWidth="xs"
				onClose={() => setV2({ modalCredit: false })}
			>
				<div style={{ padding: "0 10px" }}>
					<h2>Top Up Credits</h2>
					<hr />
				</div>
				<div style={{ padding: 10 }}>
					<h3 style={{ marginTop: -5 }}>How To Top Up</h3>
					<ol type="number">
						<li>Login to your 9 participating Major Bank in Singapore.</li>
						<li>PayNow to (Mobile) 86232830 (Tai Boon)</li>
						<li>
							Enter the amount you wish to deposit, with your Registered mobile
							number under Comments.
						</li>
						<li>
							Share your transfer receipt by WhatsApp/ SMS to{" "}
							<a
								href="https://sgpoolsretailer.com/support"
								target="_blank"
								rel="noreferrer"
							>
								https://sgpoolsretailer.com/support
							</a>
						</li>
						<li>
							Once payment has been confirmed, funds will be transferred to your
							account immediately
						</li>
					</ol>
					<div style={{ display: "flex" }}>
						<Button onClick={() => setV2({ modalCredit: false })}>Close</Button>
						<div style={{ flexGrow: 1 }} />
						<Button
							size="small"
							style={{ background: "red" }}
							onClick={() => reqLogout.handleTrigger()}
						>
							Logout
						</Button>
					</div>
				</div>
			</Dialog>

			<Dialog open={Maintenance} maxWidth="sm">
				<div style={{ padding: "24px 36px", textAlign: "center" }}>
					<h2
						style={{ fontFamily: "arial", textAlign: "center", fontSize: 36 }}
					>
						Currently Under Maintenance🙇
					</h2>
					<Button
						style={{ fontSize: 24 }}
						onClick={() => window.location.reload()}
					>
						Reload The Page
					</Button>
				</div>
			</Dialog>
			<If
				condition={
					process.env.REACT_APP_YES_APP !== undefined &&
					hist.location.pathname === "/"
				}
			>
				<Then>
					<Dialog
						open={v.popup && app_pop_up !== "empty"}
						maxWidth="sm"
						// onClose={() => dispatch(setPopUp({ read: true }))}
						onClose={() => setV2({ popup: false })}
					>
						<div style={{ padding: "24px 36px", textAlign: "center" }}>
							<p
								style={{
									fontFamily: "arial",
									textAlign: "center",
									fontSize: 24,
								}}
							>
								{app_pop_up}
							</p>
							<Button href={app_pop_up_link} target="_blank" rel="noreferrer">
								Support
							</Button>
							<br />
							<br />
							<Button
								style={{ fontSize: 24 }}
								// onClick={() => dispatch(setPopUp({ read: true }))}
								onClick={() => setV2({ popup: false })}
								className="btn-sm"
							>
								Close
							</Button>
						</div>
					</Dialog>
				</Then>
			</If>
			<Typography component="div" className="main-container">
				<If condition={token && creditBalance(router)}>
					<Then>
						<div
							style={{
								backgroundColor: "rgb(252, 195, 1)",
								color: "#222",
								fontSize: 15,
								cursor: "pointer",
							}}
							onClick={() => {
								hist.push("/retailer-account");
							}}
						>
							<p
								style={{
									margin: 0,
									padding: "9px 24px",
									fontWeight: "500",
									textAlign: "left",
								}}
							>
								Credit Balance: <b>SGD {credits}</b>
							</p>
						</div>
					</Then>
				</If>
				<div className="top-bg"></div>
				<div className="content">
					<If
						condition={
							token ||
							process.env.REACT_APP_NAME !== "SGPools" ||
							process.env.REACT_APP_YES_APP !== undefined
						}
					>
						<Then>
							{router === "/" && (
								<div
									style={{
										backgroundColor: style.color,
										color: "#fff",
										padding: "12px 24px",
										textTransform: "uppercase",
										textAlign: "center",
										fontWeight: "bold",
										letterSpacing: 1,
									}}
								>
									{process.env.REACT_APP_YES_APP !== undefined && !token ? (
										<>Illustration Only</>
									) : process.env.REACT_APP_NAME === "SGPools" ? (
										<>Digital Retailer</>
									) : (
										<>Digital Retailer</>
									)}
								</div>
							)}
							{}
						</Then>
					</If>
					<If
						condition={(() => {
							if (process.env.REACT_APP_YES_APP === undefined) {
								return token || process.env.REACT_APP_NAME !== "SGPools";
							} else {
								return true;
							}
						})()}
					>
						<Then>
							<Switch>
								<Route exact path="/" component={Home} />
								<Route path="/place-bet" component={PlaceBet} />
								<Route path="/personal-details" component={PersonalDetails} />
								<Route
									path="/lottery-bet-slip/:paymentType?/:paymentStatus?/:bookingNo?"
									component={LotteryBetSlip}
								/>
								<Route
									path="/thank-you/:paymentType?/:paymentStatus?/:bookingNo?"
									component={Final}
								/>

								<Route path="/choose-bet-check" component={ChooseBetCheck} />
								<Route path="/check/:bookingNo" component={BookingCheck} />
								{/* <Route path="/checkbet/:device?" component={BookingList} /> */}
								<Route path="/booking" component={Booking} />
								<Route path="/credit-history" component={PaymentHistory} />

								<Route path="/retailer-account" component={RetailerAccount} />
								<Route path="/deposit" component={Deposit} />
								<Route path="/withdrawals" component={Withdrawals} />

								<Route path="/refer" component={Refer} />
								<Route path="/refer-confirm/:code" component={Home} />
								<Route path="/toto" component={Toto} />
								<Route
									path="/personal-details-toto"
									component={TotoPersonalDetails}
								/>
								<Route path="/checkout-toto" component={TotoCheckout} />
								<Route path="/settings" component={Set} />
								<Route path="/agent" component={Agent} exact />
								<Route path="/agent/history" component={AgentHistory} />
								<Route path="/debug" component={Debug} />
								<Route path="*" component={NotFound} />
							</Switch>
						</Then>
					</If>
				</div>
			</Typography>
		</Container>
	);
});

export default App;
